import { Edge, EdgeProps, Node } from '@xyflow/react'

export enum NodeType {
  CIRCLE = 'circle',
  SQUARE = 'square',
  DIAMOND = 'diamond',
  INPUT_NODE = 'inputNode',
  LABEL_NODE = 'labelNode',
  OUTPUT_NODE = 'outputNode',
}

export enum EdgeType {
  SOLID_LINE = 'solidLine',
  DASHED_LINE = 'dashedLine',
}

export type PfdNode = Node<PfdNodeDataType>

export type PfdNodeDataType = {
  label: string
  link?: {
    entryType: string
    entryID: string
    siteID: string
  }
  rotation?: number
}

export type PfdEdge = Edge<PfdEdgeDataType>

export type PfdEdgeDataType = {
  confirmedEdge?: boolean
}

export type PfdEdgeProps = EdgeProps & {
  data: PfdEdgeDataType
}

export type PfdData = {
  nodes: PfdNode[]
  edges: PfdEdge[]
}

export type PfdMetadata = {
  name: string
}

export type ProcessFlowDiagramDataJSON = {
  metadata: PfdMetadata
  diagram: PfdData
}

export type ProcessFlowDiagramEntry = {
  entry: {
    id: string
    type: 'process-flow-diagram'
    data: ProcessFlowDiagramDataJSON
    tags: {
      site: string
      organization: string
    }
    created_by: string
    created_at: string
    updated_at: string
    last_updated_by: string
  }
}
